import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AdminService } from '../../../services/admin.service';
import { ServerResponseObject } from '../../../interfaces/ServerResponse';
import { Company, PostCompany } from '../../../interfaces/admin/Company';

@Component({
  selector: 'app-add-company-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatProgressSpinner
  ],
  templateUrl: './add-company-dialog.component.html',
  styleUrl: './add-company-dialog.component.scss'
})
export class AddCompanyDialogComponent {
  addCompanyForm = new FormGroup({
    company_id: new FormControl('', [Validators.required]),
    company_name: new FormControl('', [Validators.required]),
    country_head_quarters: new FormControl('', [Validators.required]),
    description: new FormControl(''),
    contact: new FormControl('', [Validators.required]),
  });

  constructor(private adminService: AdminService) { }

  private readonly dialogRef = inject(MatDialogRef<AddCompanyDialogComponent>, { optional: true });

  isLoading: boolean = false;

  onAddCompany() {
    if (!this.addCompanyForm.valid) return;
    let json = this.addCompanyForm.value;
    this.isLoading = true;
    this.adminService.addCompany(json as PostCompany).subscribe({
      next: (res: ServerResponseObject<Company>) => {
        this.isLoading = false;
        this.dialogRef?.close(true);
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
}
